import { render } from "./coopCustom.vue?vue&type=template&id=31afca40&scoped=true"
import script from "./coopCustom.vue?vue&type=script&lang=js"
export * from "./coopCustom.vue?vue&type=script&lang=js"

import "./coopCustom.vue?vue&type=style&index=0&id=31afca40&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31afca40"]])

export default __exports__